 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"AddDualAssets":"AddDualAssets","AddLiquidity":"AddLiquidity","AddSingleAsset":"AddSingleAsset","Dashboard~Stake":"Dashboard~Stake","Stake":"Stake","Dashboard~TradeShow":"Dashboard~TradeShow","Dashboard":"Dashboard","Liquidity":"Liquidity","Market":"Market","Mint":"Mint","MintIndex":"MintIndex","NotFound":"NotFound","Redeem":"Redeem","RemoveDualAssets":"RemoveDualAssets","RemoveLiquidity":"RemoveLiquidity","RemoveSingleAsset":"RemoveSingleAsset","StakeIndex":"StakeIndex","StakeShow":"StakeShow","Swap":"Swap","TradeShow~Zap~ZapShow":"TradeShow~Zap~ZapShow","TradeShow":"TradeShow","Zap~ZapShow":"Zap~ZapShow","Zap":"Zap","ZapShow":"ZapShow"}[chunkId]||chunkId) + "." + {"AddDualAssets":"b5b8186d","AddLiquidity":"826d856f","AddSingleAsset":"aeb364c4","Dashboard~Stake":"a1679b53","Stake":"67dcf873","Dashboard~TradeShow":"2599943d","Dashboard":"09f5d323","Liquidity":"2f0d2d8b","Market":"9addf0d0","Mint":"7666f44e","MintIndex":"53f4d44f","NotFound":"1e195450","Redeem":"b76c870c","RemoveDualAssets":"e8bfe736","RemoveLiquidity":"49b24aa8","RemoveSingleAsset":"d6328b06","StakeIndex":"e6a7a4e6","StakeShow":"08f7480f","Swap":"9877161c","TradeShow~Zap~ZapShow":"e7c10a13","TradeShow":"582df559","Zap~ZapShow":"516af5e5","Zap":"2184713e","ZapShow":"5fee5339","chunk-06ee0fdc":"c6b94897","chunk-07c95ab4":"f46b77f9","chunk-07c95b10":"d4848970","chunk-07c9c38e":"5721b3a1","chunk-07ca38c8":"74af25a9","chunk-07ca421c":"b736f84b","chunk-07cbefda":"f7b7884a","chunk-07ccdb2a":"fa311a0a","chunk-07cceb86":"fa9410cb","chunk-07f1cc56":"4c1e5aff","chunk-07f24bd6":"f771730e","chunk-07f305f2":"9068be57","chunk-07f333fe":"3f936d52","chunk-07f34af8":"c241b125","chunk-07f47732":"2ab7a5fb","chunk-07f5e290":"07f05504","chunk-07f6c20a":"aa739d5b","chunk-07f8b314":"22f6790e","chunk-07f9031e":"628af1e1","chunk-07f91110":"ec42ba1b","chunk-07f99836":"b60c8bec","chunk-07f9a910":"7f5bab6d","chunk-07fa7a86":"c4f9c7e9","chunk-07fa888e":"d8b592b6","chunk-1c49310a":"a106928e","chunk-22c978de":"f6337a69","chunk-2d0a441e":"94b18364","chunk-2d0aacb9":"62e29e83","chunk-2d0c4265":"556de0ee","chunk-2d0d08fe":"6f1b2bc7","chunk-2d0d79ea":"0191f187","chunk-2d0de3d1":"f783900a","chunk-2d0e1fdd":"71af374f","chunk-2d2077e6":"ce31befa","chunk-2d207800":"66670b51","chunk-2d20f575":"a69b7c75","chunk-2d20fb24":"4ecc9c5d","chunk-2d216366":"310c8a1c","chunk-3c50d276":"fe044f45","chunk-43cfcce1":"8d03856c","chunk-510c8326":"7a33d849","chunk-667b74d5":"299ea6f7","chunk-6861bf2a":"3e8d2906","chunk-bef00f0e":"73c03349","chunk-24633334":"24e8755c","chunk-3bdc39fb":"a6e03bd3","chunk-782eca50":"99a5d9d8","chunk-6f863d87":"bb6d907a","chunk-74ceccd2":"0296ae38","chunk-77299705":"766f0265","chunk-c192c05c":"00c10029","chunk-2d0abf81":"b4f26025","chunk-f8736792":"3ea67bb6","chunk-c43186fc":"3fd98324","chunk-090c55f6":"c9c1a283","chunk-03c5620e":"563fcefd","chunk-731d3048":"ad0a4409","chunk-d826f836":"dedee718","chunk-4810837e":"1528972d","chunk-2d0b93f9":"cea97b42","chunk-f1bae02a":"ee14bd6d","chunk-2c6e76a8":"5c6682b6","chunk-317a20ed":"11ea9626","chunk-78ed7412":"2e81ad96","chunk-2d0bff15":"e4db614c","chunk-229e8051":"5016d796","chunk-069843b2":"14bf60db","chunk-5c00f31f":"eb81c7eb","chunk-2d0f1539":"1d837050","chunk-70a622be":"f9072b92","chunk-2d0d9f40":"9926e7c5","chunk-75ac7f12":"c4a71177","chunk-0b15b46c":"c8ddafd3","chunk-3a7b7108":"c6c46bbd","chunk-67efe2ea":"b407b9d3","chunk-8cb906fa":"65ed73e9","chunk-5380b55d":"00b7ed0a","chunk-3f528083":"9eedb231"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"Dashboard":1,"RemoveDualAssets":1,"RemoveSingleAsset":1,"TradeShow":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"AddDualAssets":"AddDualAssets","AddLiquidity":"AddLiquidity","AddSingleAsset":"AddSingleAsset","Dashboard~Stake":"Dashboard~Stake","Stake":"Stake","Dashboard~TradeShow":"Dashboard~TradeShow","Dashboard":"Dashboard","Liquidity":"Liquidity","Market":"Market","Mint":"Mint","MintIndex":"MintIndex","NotFound":"NotFound","Redeem":"Redeem","RemoveDualAssets":"RemoveDualAssets","RemoveLiquidity":"RemoveLiquidity","RemoveSingleAsset":"RemoveSingleAsset","StakeIndex":"StakeIndex","StakeShow":"StakeShow","Swap":"Swap","TradeShow~Zap~ZapShow":"TradeShow~Zap~ZapShow","TradeShow":"TradeShow","Zap~ZapShow":"Zap~ZapShow","Zap":"Zap","ZapShow":"ZapShow"}[chunkId]||chunkId) + "." + {"AddDualAssets":"31d6cfe0","AddLiquidity":"31d6cfe0","AddSingleAsset":"31d6cfe0","Dashboard~Stake":"31d6cfe0","Stake":"31d6cfe0","Dashboard~TradeShow":"31d6cfe0","Dashboard":"f048029b","Liquidity":"31d6cfe0","Market":"31d6cfe0","Mint":"31d6cfe0","MintIndex":"31d6cfe0","NotFound":"31d6cfe0","Redeem":"31d6cfe0","RemoveDualAssets":"f048029b","RemoveLiquidity":"31d6cfe0","RemoveSingleAsset":"f048029b","StakeIndex":"31d6cfe0","StakeShow":"31d6cfe0","Swap":"31d6cfe0","TradeShow~Zap~ZapShow":"31d6cfe0","TradeShow":"aabc1e74","Zap~ZapShow":"31d6cfe0","Zap":"31d6cfe0","ZapShow":"31d6cfe0","chunk-06ee0fdc":"31d6cfe0","chunk-07c95ab4":"31d6cfe0","chunk-07c95b10":"31d6cfe0","chunk-07c9c38e":"31d6cfe0","chunk-07ca38c8":"31d6cfe0","chunk-07ca421c":"31d6cfe0","chunk-07cbefda":"31d6cfe0","chunk-07ccdb2a":"31d6cfe0","chunk-07cceb86":"31d6cfe0","chunk-07f1cc56":"31d6cfe0","chunk-07f24bd6":"31d6cfe0","chunk-07f305f2":"31d6cfe0","chunk-07f333fe":"31d6cfe0","chunk-07f34af8":"31d6cfe0","chunk-07f47732":"31d6cfe0","chunk-07f5e290":"31d6cfe0","chunk-07f6c20a":"31d6cfe0","chunk-07f8b314":"31d6cfe0","chunk-07f9031e":"31d6cfe0","chunk-07f91110":"31d6cfe0","chunk-07f99836":"31d6cfe0","chunk-07f9a910":"31d6cfe0","chunk-07fa7a86":"31d6cfe0","chunk-07fa888e":"31d6cfe0","chunk-1c49310a":"31d6cfe0","chunk-22c978de":"31d6cfe0","chunk-2d0a441e":"31d6cfe0","chunk-2d0aacb9":"31d6cfe0","chunk-2d0c4265":"31d6cfe0","chunk-2d0d08fe":"31d6cfe0","chunk-2d0d79ea":"31d6cfe0","chunk-2d0de3d1":"31d6cfe0","chunk-2d0e1fdd":"31d6cfe0","chunk-2d2077e6":"31d6cfe0","chunk-2d207800":"31d6cfe0","chunk-2d20f575":"31d6cfe0","chunk-2d20fb24":"31d6cfe0","chunk-2d216366":"31d6cfe0","chunk-3c50d276":"31d6cfe0","chunk-43cfcce1":"31d6cfe0","chunk-510c8326":"31d6cfe0","chunk-667b74d5":"31d6cfe0","chunk-6861bf2a":"31d6cfe0","chunk-bef00f0e":"31d6cfe0","chunk-24633334":"31d6cfe0","chunk-3bdc39fb":"31d6cfe0","chunk-782eca50":"31d6cfe0","chunk-6f863d87":"31d6cfe0","chunk-74ceccd2":"31d6cfe0","chunk-77299705":"31d6cfe0","chunk-c192c05c":"31d6cfe0","chunk-2d0abf81":"31d6cfe0","chunk-f8736792":"31d6cfe0","chunk-c43186fc":"31d6cfe0","chunk-090c55f6":"31d6cfe0","chunk-03c5620e":"31d6cfe0","chunk-731d3048":"31d6cfe0","chunk-d826f836":"31d6cfe0","chunk-4810837e":"31d6cfe0","chunk-2d0b93f9":"31d6cfe0","chunk-f1bae02a":"31d6cfe0","chunk-2c6e76a8":"31d6cfe0","chunk-317a20ed":"31d6cfe0","chunk-78ed7412":"31d6cfe0","chunk-2d0bff15":"31d6cfe0","chunk-229e8051":"31d6cfe0","chunk-069843b2":"31d6cfe0","chunk-5c00f31f":"31d6cfe0","chunk-2d0f1539":"31d6cfe0","chunk-70a622be":"31d6cfe0","chunk-2d0d9f40":"31d6cfe0","chunk-75ac7f12":"31d6cfe0","chunk-0b15b46c":"31d6cfe0","chunk-3a7b7108":"31d6cfe0","chunk-67efe2ea":"31d6cfe0","chunk-8cb906fa":"31d6cfe0","chunk-5380b55d":"31d6cfe0","chunk-3f528083":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
